// react
import { MouseEvent } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Invoice } from '../../../@types';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditInvoice, FormEditInvoiceProps } from '../../forms/FormEditInvoice/FormEditInvoice';

// props
export interface DialogEditInvoiceProps {
	invoice: Invoice | null;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: FormEditInvoiceProps['onSuccess'];
}

export const DialogEditInvoice = ({
	invoice,
	isOpen,
	onClose,
	onSuccess,
}: DialogEditInvoiceProps) => {
	// hooks
	const { t } = useTranslation();

	if (!invoice) {
		return <></>;
	}

	return (
		<DialogActions
			fullScreen={true}
			hasClose={true}
			isOpen={isOpen}
			onClose={(e: MouseEvent<HTMLButtonElement>) => {
				e.preventDefault();
				onClose();
			}}
			subtitle={{
				children: invoice.num || t('na'),
			}}
			title={{
				children: `${t('editInvoice')}`,
			}}
			maxWidth={620}>
			<FormEditInvoice invoice={invoice} onCancel={onClose} onSuccess={onSuccess} />
		</DialogActions>
	);
};
